<template>
  <ExternalQueryList
      endpoint="/api/v2/partnership-activity-mail-recipients"
      :endpoint-filters="{partnership_activity_mail_id: partnershipActivityMail.id}"
      :headlines="headlines"
      :checkbox-column-width="2"
      :button-column-width="2"
      :can-update="() => true"
      :can-destroy="() => true"
      @show="partnershipActivityMailRecipient => edit(partnershipActivityMailRecipient)"
  >
    <template v-slot:default="{ row: partnershipActivityMailRecipient }">
      <td class="table__ellipsis">
        {{ partnershipActivityMailRecipient.attributes.name }}
      </td>

      <td class="table__ellipsis">
        {{ partnershipActivityMailRecipient.attributes.email }}
      </td>
    </template>

    <template v-slot:modals="{ selected, update, load }">
      <CreateModal :partnership-activity-mail="partnershipActivityMail" @created="load"/>

      <EditModal :partnership-activity-mail-recipient="editing" @updated="update"/>
    </template>
  </ExternalQueryList>
</template>

<script>
import CreateModal from "../Modals/Create.vue";
import EditModal from "../Modals/Edit.vue";
import ExternalQueryList from '../../../Panels/Lists/ExternalQuery'

export default {
  components: {CreateModal, EditModal, ExternalQueryList},

  props: {
    partnershipActivityMail: {
      required: true
    }
  },

  data() {
    return {
      editing: null
    }
  },

  computed: {
    headlines() {
      return [
        {width: 10, text: 'Name'},
        {width: 10, text: 'Email'},
      ]
    },
  },

  methods: {
    edit(partnershipActivityMailRecipient) {
      this.editing = partnershipActivityMailRecipient

      $("#edit-partnership-activity-mail-recipient-modal").modal("show")
    }
  }
}
</script>
